var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPrint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E6E6E6",
    opacity: 0.7,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M17.25 10c.5 0 .9.2 1.23.52.33.33.52.74.52 1.23v3.06c0 .14-.05.25-.14.33-.08.08-.19.11-.3.11h-1.31v2.63a.89.89 0 0 1-.88.87H7.63A.87.87 0 0 1 7 18.5a.87.87 0 0 1-.25-.63v-2.62H5.44c-.14 0-.25-.03-.33-.1-.08-.1-.11-.2-.11-.34v-3.06c0-.5.16-.9.5-1.23.32-.33.76-.52 1.25-.52V5.62a.89.89 0 0 1 .88-.88h7.51c.22.01.44.1.6.26L17 6.25c.17.17.25.39.25.6V10zm-1.75 7v-2.63h-7V17h7zm0-6.13V8.25h-1.31c-.14 0-.25-.03-.33-.1-.08-.1-.11-.2-.11-.34V6.5H8.5v4.38h7zm1.31 1.97c.17 0 .33-.05.47-.19.1-.1.19-.27.19-.46a.78.78 0 0 0-.2-.47.78.78 0 0 0-.46-.19.66.66 0 0 0-.65.66c0 .19.05.35.19.46.1.14.27.2.46.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
export default __webpack_public_path__ + "static/media/icon-print.ab5cfe529e94dafa91ea47976f78b34d.svg";
export { ForwardRef as ReactComponent };